import React, { useEffect } from 'react'
import { Document, Page, View, Image, Text, StyleSheet } from '@react-pdf/renderer'
import Anexo from '../../assets/forms/anexo1.png'
import AnexoB from '../../assets/forms/anexo2.png'






const AnexoPDF = (props) => {


  return (
    <Document>
       <Page size='A4'>
        <View style={styles.container}>
            <Image
                style={styles.image}
                src={Anexo}
            />
             <Text style={styles.text}> {props.props[1].nombreApellido} </Text>
             <Text style={styles.text1}> {props.props[1].dni} </Text>
             <Text style={styles.text2}> {props.props[1].domicilio} </Text>
             <Text style={styles.text3}> {props.props[0].historiaClinica}</Text>
             <Text style={styles.text8}>{props.props[0].patologias}</Text>
             <Text style={styles.text85}>{props.props[0].tratamiento}</Text>
             <Text style={styles.text9}>{props.props[0].procedimientos}</Text>
             <Text style={styles.text10}>{props.props[0].beneficios}</Text>
             <Text style={styles.text11}>{props.props[0].consecuencias}</Text>
             <Text style={styles.text12}>{props.props[0].riesgos}</Text>
            <Image
                style={styles.image}
                src={AnexoB}
            />
            
            <Text style={styles.text18}>{props.props[0].fechaDelDia?.slice(8,10)}</Text>
            <Text style={styles.text17}>{props.props[0].mes}</Text>
                    
             {
              props.ddjj.length > 0 ?
              <Image src={props.ddjj[0].firma} alt='firmaUsuario' style={styles.text13} /> : 'No hay Firma'
             } 

            <Text style={styles.text14}> {props.props[1].nombreApellido}</Text>

        </View>
       </Page>
    </Document>
  )
}

export default AnexoPDF

const styles = StyleSheet.create({
    text: {
        position: 'absolute',
        top: '160',
        left: '32%',
        transform: 'translate(-50%, -50%)',
        fontSize: '8pt',
        fontWeight: 'bold',
        color: 'black',
        textShadow: '2px 2px 4px #000000',
      },
    text1: {
        position: 'absolute',
        top: '160',
        left: '370',
        transform: 'translate(-50%, -50%)',
        fontSize: '8pt',
        fontWeight: 'bold',
        color: 'black',
        textShadow: '2px 2px 4px #000000',
      },
    text2: {
        position: 'absolute',
        top: '175',
        left: '120',
        transform: 'translate(-50%, -50%)',
        fontSize: '8pt',
        fontWeight: 'bold',
        color: 'black',
        textShadow: '2px 2px 4px #000000',
      },
    text3: {
        position: 'absolute',
        top: '174',
        left: '370',
        transform: 'translate(-50%, -50%)',
        fontSize: '8pt',
        fontWeight: 'bold',
        color: 'black',
        textShadow: '2px 2px 4px #000000',
      },
    text4: {
        position: 'absolute',
        top: '260',
        left: '440',
        transform: 'translate(-50%, -50%)',
        fontSize: '8pt',
        fontWeight: 'bold',
        color: 'black',
        textShadow: '2px 2px 4px #000000',
      },
    text5: {
        position: 'absolute',
        top: '260',
        left: '580',
        transform: 'translate(-50%, -50%)',
        fontSize: '8pt',
        fontWeight: 'bold',
        color: 'black',
        textShadow: '2px 2px 4px #000000',
      },
    text6: {
        position: 'absolute',
        top: '272',
        left: '200',
        transform: 'translate(-50%, -50%)',
        fontSize: '8pt',
        fontWeight: 'bold',
        color: 'black',
        textShadow: '2px 2px 4px #000000',
      },
    text7: {
        position: 'absolute',
        top: '274',
        left: '420',
        transform: 'translate(-50%, -50%)',
        fontSize: '8pt',
        fontWeight: 'bold',
        color: 'black',
        textShadow: '2px 2px 4px #000000',
      },
    text8: {
        position: 'absolute',
        top: '290',
        left: '130',
        transform: 'translate(-50%, -50%)',
        fontSize: '8pt',
        fontWeight: 'bold',
        color: 'black',
        textShadow: '2px 2px 4px #000000',
      },
    text85: {
        position: 'absolute',
        top: '390',
        left: '20%',
        right: "7%",
        transform: 'translate(-50%, -50%)',
        fontSize: '8pt',
        fontWeight: 'bold',
        color: 'black',
        textShadow: '2px 2px 4px #000000',
      },
    text9: {
        position: 'absolute',
        top: '520',
        left: '20%',
        right: "7%",
        transform: 'translate(-50%, -50%)',
        fontSize: '8pt',
        fontWeight: 'bold',
        color: 'black',
        textShadow: '2px 2px 4px #000000',
      },
    text10: {
        position: 'absolute',
        top: '627',
        left: '20%',
        right: "7%",
        transform: 'translate(-50%, -50%)',
        fontSize: '8pt',
        fontWeight: 'bold',
        color: 'black',
        textShadow: '2px 2px 4px #000000',
      },
    text11: {
        position: 'absolute',
        top: '680',
        left: '20%',
        right: "7%",
        transform: 'translate(-50%, -50%)',
        fontSize: '8pt',
        fontWeight: 'bold',
        color: 'black',
        textShadow: '2px 2px 4px #000000',
      },
    text12: {
        position: 'absolute',
        top: '720',
        left: '20%',
        right: "7%",
        transform: 'translate(-50%, -50%)',
        fontSize: '8pt',
        fontWeight: 'bold',
        color: 'black',
        textShadow: '2px 2px 4px #000000',
      },
    text13: {
        position: 'absolute',
        top: '640',
        left: '50%',
        width: '50',
        height: '50'
      },
    text14: {
      position: 'absolute',
      top: '740',
      left: '60%',
      transform: 'translate(-50%, -50%)',
      fontSize: '8pt',
      fontWeight: 'bold',
      color: 'black',
      textShadow: '2px 2px 4px #000000',
      },
      text15: {
        position: 'absolute',
        top: '10',
        left: '50%',
        width: '100',
        height: '100'
      },
      text16: {
        position: 'absolute',
        top: '153',
        left: '60%',
        transform: 'translate(-50%, -50%)',
        fontSize: '8pt',
        fontWeight: 'bold',
        color: 'black',
        textShadow: '2px 2px 4px #000000',
        },
      text17: {
        position: 'absolute',
        top: '377',
        left: '93.4%',
        transform: 'translate(-50%, -50%)',
        fontSize: '10pt',
        fontWeight: 'bold',
        color: 'black',
        textShadow: '2px 2px 4px #000000',
        backgroundColor:"white",
        height:"15px",
        width:"100px",
      },
      text18: {
        position: 'absolute',
        top: '378.7',
        left: '80.1%',
        transform: 'translate(-50%, -50%)',
        fontSize: '8pt',
        fontWeight: 'bold',
        color: 'black',
        textShadow: '2px 2px 4px #000000',
        backgroundColor:"white",
        height:"15px",
        width:"8px",
      },
})
